export const getVar = (name: string) => {
  const styles = getComputedStyle(document.body)
  return styles.getPropertyValue(name).trim()
}

export const getColors = () => ({
  white: getVar('--white-color'),
  base: getVar('--base-color'),
  grayDark: getVar('--gray-dark-color'),
  graySemiDark: getVar('--gray-semi-dark-color'),
  grayMedium: getVar('--gray-medium-color'),
  grayLight: getVar('--gray-light-color'),
  grayDefault: getVar('--gray-default-color'),
  blueDefault: getVar('--blue-default-color'),
  blueLight: getVar('--blue-light-color'),
  blueLightTransparent: getVar('--blue-light-transparent-color'),
  blueSemiLight: getVar('--blue-semi-light-color'),
  blueTransparent: getVar('--blue-transparent-color'),
  blueSemiTransparent: getVar('--blue-semi-transparent-color'),
  redDefault: getVar('--red-default-color'),
  greenDefault: getVar('--green-default-color'),
  yellowDefault: getVar('--yellow-default-color'),
})
